import { PULSE_CHECK_IN_PAUSED } from "@/config/pulse";
import { useRemoteConfigBoolean } from "@/context/RemoteConfigContext";

/**
 * Whether the Pulse check-in is on for this environment: the code-level pause
 * wins, then the `show_pulse_check` remote-config flag. Every surface that
 * shows or links to the check-in reads this so they switch together.
 */
export function usePulseCheckInEnabled(): boolean {
  const flag = useRemoteConfigBoolean("show_pulse_check");
  return !PULSE_CHECK_IN_PAUSED && flag;
}
